























import type { MergeValues, EBlockWidth, Link } from '@getaccept/editor-lib';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import ThemedButton from '@getaccept/lib-shared/src/components/ThemedButton.vue';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import ProsemirrorViewerInput from './ProsemirrorViewerInput.vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';

export default defineComponent({
  name: 'EditorNodeLink',
  components: {
    ProsemirrorViewerInput,
    ThemedButton,
    EditorNodeWrapper,
  },
  props: {
    node: {
      type: Object as PropType<Link>,
      default: () => ({}),
    },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
    parentFirstChild: { type: Boolean, default: false },
    parentLastChild: { type: Boolean, default: false },
    blockWidthClass: { type: String as PropType<EBlockWidth>, default: null },
    theme: { type: Object as PropType<SigningTheme>, default: () => ({}) },
  },
  setup(props, { emit }) {
    const handleClick = () => {
      const url = UrlHelper.getHttpsUrl(props.node.linkUrl);
      window.open(url, '_blank');
      emit('node-click', { nodeId: props.node.id });
    };

    return {
      props,
      handleClick,
    };
  },
});
